import React from "react";
import "../styles/ChecklistCard.css";
import Clause from "./Clause";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function ABClauseCard({
  ClauseDataCommon,
  ClauseDataSituational,
  ClauseCardDescription,
}) {
  return (
    <div className="checklist-card checklist-card-modern">
      <div className="flex flex-wrap checklist-card-header">
        <div>Common Conditions/Clauses</div>
      </div>
      <div className="clause-card-content">
        <div
          className="clause-card-description"
          dangerouslySetInnerHTML={{
            __html: ClauseCardDescription[0].text,
          }}
        />
        <div className="clause-warning">
          <div className="clause-warning-icon">
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          </div>
          <div>
            If your Client chooses not to include any recommended Conditions in
            their offer, or chooses not to follow any other advice given, be sure
            to complete this form:{" "}
            <strong>
              Buyer Acknowledgement Regarding Conditions in Purchase Agreement
            </strong>
            . <br />
            <a
              href="https://drive.google.com/drive/folders/1i_gmDWWPJHZx8vbKUAnY-8U5C8l4Sdpi"
              target="_blank"
              rel="noreferrer"
            >
              Click here
            </a>{" "}
            to get the form.
          </div>
        </div>
      {ClauseDataCommon.length === 0 ? (
        ""
      ) : (
        <h2 className="clause-section-title">Conditions in the Contract</h2>
      )}

      <ul className="clause-list">
        {ClauseDataCommon.map((item, index) => (
          <div key={index} className="clause-list-item">
            <Clause Clause={item} />
          </div>
        ))}
      </ul>
      {ClauseDataSituational.length === 0 ? (
        ""
      ) : (
        <h2 className="clause-section-title">Common Situational Terms & Conditions</h2>
      )}

      <ul className="clause-list">
        <ul className="clause-list">
          {ClauseDataSituational.map((item, index) => (
            <div key={index} className="clause-list-item">
              <Clause Clause={item} />
            </div>
          ))}
        </ul>
      </ul>
      </div>
    </div>
  );
}
